/**
Project: Voice Panel (c)
Title: Numbers List
Description: Component to display the numbers list and also to Add, Buy, Export and Import the numbers.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Flex,
  Text,
  Input,
  Button,
  Table,
  TableRow,
  SearchIcon,
  CloseIcon,
  TableCell,
  AcceptIcon,
  EditIcon,
  Popup,
  Dialog,
  Divider,
  TrashCanIcon,
  PopupIcon,
  Tooltip,
  RetryIcon,
  Checkbox,
  Image,
  FilterIcon,
} from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import axios from "axios";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import TokenUtil from "../../../../core/helpers/token-util";
import {
  showPageWaitDialog,
  hidePageWaitDialog,
  capitalizeFirstLetter,
  handleCommunicationPlatformName,
} from "../../common/actions/general-actions";
import ResponseUtil from "../../../../core/helpers/response-util";
import PageLoader from "../../common/helpers/page-loader";
import TableHeaderColumn from "../../common/helpers/table-header-column";
import AlertInfoMessage from "../../common/helpers/alert-info-message";
import AlertSuccessMessage from "../../common/helpers/alert-success-message";
import AlertErrorMessage from "../../common/helpers/alert-error-message";
import TablePagination from "../../common/helpers/table-pagination";
import { AppConfigProps } from "../../../../core/settings/app-config";
import { VoiceAdminURLProps } from "../../common/settings/voice-admin-urls";
import {
  manageError,
  checkIdentitySessionValid,
  checkIdentitySession,
} from "../../../../core/actions/common-actions";
import {
  setInventoryNumbersPageAllRecords,
  getTenantAccountsNumberSyncNow,
  tenentAccountNumberSyncNow,
  getInventoryNumbers,
  getInventoryNumbersPropagation,
  setInventoryNumbersDisplayRecords,
  setInventoryNumbersPageRecords,
  searchInventoryNumbers,
  sortInventoryNumbers,
  sliceInventoryNumbers,
  getInventoryDownloadFileData,
  deleteInventoryNumber,
  getDevicesByNumberId,
  downloadDeviceFileData,
  getDevice,
  getCommunicationPlatformByName,
  numberMultipleFilterCriteriaArray,
} from "../actions/number-inventory-actions";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import {
  InventoryTableHeaderColumns,
  DeviceModalTableHeaderColumns,
} from "../settings/numbers-table-header-columns";
import NumberImport from "../components/number-import";
import NumberExport from "../components/number-export";
import { AppPageTitle } from "../../../../core/components/app-page-title";
import Texty from "react-texty";
import moment from "moment";
import _ from "lodash";
import { AppURLProps } from "../../../../core/settings/app-urls";
import NumberFilter from "../components/number-filter";
import classNames from "classnames";
import NumbersSyncDialog from "../../common/helpers/numbers-sync-dialog";

class NumberList extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_common = "vpa_common";
  _intl_ns_vpa_number_inventory = "vpa_number_inventory";
  constructor(props) {
    super(props);
    this.state = {
      isPageDataFetched: false,
      searchValue: "",
      searchKeyword: "",
      isListDataFetched: false,
      isSyncTenantAccountsFetched: false,
      isSyncProcessStarted: false,
      isFilterPanelOpen: false,
      pageOffset: VoiceAdminConstants.TABLE_DATA.PAGE_OFFSET_DEFAULT,
      pageLimit: VoiceAdminConstants.TABLE_DATA.PAGE_LIMIT_DEFAULT,
      sortedOrder: VoiceAdminConstants.TABLE_DATA.SORT_ORDER.ASCENDING,
      sortedColumn: "numberCountryName",
      showAlert: false,
      showSyncAlert: false,
      showExportStatusDialog: false,
      showImportDialog: false,
      showExportDialog: false,
      showSyncDialog: false,
      orderedNumbersDialog: false,
      numbersStatistics: {},
      inventoryTableHeaderColumns: this.initInventoryTableHeaderColumns(),
      numberFilterData: this.initNumberFilterData(),
      numberFilterSelectedData: this.initNumberFilterSelectedData(),
      isAlterDataPropagated: true,
      isNumberDeleteModal: false,
      isNumberDeviceModal: false,
      isDisableNumberSync: true,
      isDisableAgreeSync: false,
      numbersPropagation: null,
      syncTenantAccountRecords: null,
      infoMessage: null,
      deviceList: [],
      devicesAllRecord: [],
    };
  }
  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    await this.loadPageData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  loadPageData = async () => {
    try {
      await this.setStateAsync({ isPageDataFetched: false });
      await this.fetchInventoryNumbers();
      await this.getInventoryStatistics();
      await this.setFilterData();
      await this.setStateAsync({ isSyncProcessStarted: false });
      await this.setStateAsync({ isPageDataFetched: true });
    } catch (err) {
      await this.setStateAsync({ isPageDataFetched: true });
      await manageError(err, this.props.history);
    }
  };

  fetchInventoryNumbers = async () => {
    let extractType = "Recent";
    await axios
      .all([
        getInventoryNumbersPropagation(extractType, this._cancelToken),
        getInventoryNumbers(this._cancelToken),
      ])
      .then(
        axios.spread(async (propagationData, inventoryNumber) => {
          if (
            inventoryNumber &&
            inventoryNumber.data &&
            inventoryNumber.status === AppConfigProps.httpStatusCode.ok &&
            inventoryNumber.data.records
          ) {
            if (inventoryNumber.data.records) {
              let records=inventoryNumber.data.records;
              if(records?.length>0){
                records=records.map(rec=>{
                  if(rec?.classification?.toLowerCase().trim()===VoiceAdminConstants.INVENTORY.CLASSIFICATION_TYPE.STORE?.toLowerCase().trim()){
                    rec.classification=VoiceAdminConstants.INVENTORY.CLASSIFICATION_TYPE.E_FAX;
                  }
                  return {...rec}
                })
              }
              await this.props.setInventoryNumbersPageAllRecords(
                records
              );
              let searchedRecords = await searchInventoryNumbers(
                this.props.inventoryNumbersAllRecords,
                this.state.searchKeyword,
                this.props.subscriberAccount?.voiceNumbersPrivilege
              );
              let sortedRecords = await sortInventoryNumbers(
                searchedRecords,
                this.state.sortedColumn,
                this.state.sortedOrder
              );
              await this.props.setInventoryNumbersDisplayRecords(sortedRecords);
              let slicedRecords = await sliceInventoryNumbers(
                this.props.inventoryNumbersDisplayRecords,
                this.state.pageOffset,
                this.state.pageLimit
              );
              await this.props.setInventoryNumbersPageRecords(slicedRecords);
              await this.setStateAsync({ isListDataFetched: true });
            }
            if (propagationData.data.result) {
              const propagation = propagationData.data.result;
              await this.setStateAsync({ numbersPropagation: propagation });
              if (
                propagation.overallStatus !==
                VoiceAdminConstants.INVENTORY.DATA_PROPAGATION
                  .OVERALL_STATUS_COMPLETED
              ) {
                if (this.state.numbersPropagation.dataType === "Numbers") {
                  await this.setStateAsync({
                    infoMessage: IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "notification.info.numbersDataPropagationInprogress"
                    ),
                  });
                } else {
                  await this.setStateAsync({
                    infoMessage: IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "notification.info.devicesDataPropagationInprogress"
                    ),
                  });
                }
                await this.setStateAsync({ isAlterDataPropagated: false });
              } else {
                await this.setStateAsync({ isAlterDataPropagated: true });
              }
            }
          }
        })
      )
      .catch(async (err) => {
        manageError(err, this.props.history);
      });
  };

  initNumberFilterData = () => {
    return {
      managedRecords: [],
      platFormRecords: [],
      countryRecords: [],
      numberTypeRecords: [],
      carrierRecords: [],
    };
  };

  initNumberFilterSelectedData = () => {
    return {
      selectedManagedStatus: "All Numbers",
      selectedPlatForms: [],
      selectedCountries: [],
      selectedNumberTypes: [],
      selectedCarriers: [],
    };
  };

  initInventoryTableHeaderColumns = () => {
    let inventoryTableHeaderColumns = [];
    if (this.props.subscriberAccount?.voiceNumbersPrivilege === true) {
      inventoryTableHeaderColumns = InventoryTableHeaderColumns(
        this._intl_ns_vpa_number_inventory
      ).map((rec) => {
        if (rec.columnId === "phoneNumber") {
          return {
            ...rec,
            cellClassName: `${rec.cellClassName}  min-w-160 max-w-160`,
          };
        } else if (rec.columnId === "classification") {
          return {
            ...rec,
            cellClassName: `${rec.cellClassName}  min-w-130 max-w-130`,
          };
        } else {
          return rec;
        }
      });
    } else {
      inventoryTableHeaderColumns = InventoryTableHeaderColumns(
        this._intl_ns_vpa_number_inventory
      )
        .map((rec) => {
          if (rec.columnId === "phoneNumber") {
            return {
              ...rec,
              cellClassName: `${rec.cellClassName}  min-w-160 max-w-160`,
            };
          } else if (rec.columnId === "classification") {
            return {
              ...rec,
              cellClassName: `${rec.cellClassName}  min-w-130 max-w-130`,
            };
          } else {
            return rec;
          }
        })
        .filter(
          (rec) =>
            rec.columnId !== "deviceType" && rec.columnId !== "carrierName"
        );
    }
    return inventoryTableHeaderColumns;
  };

  fetchDevicesByNumberId = async (numberId) => {
    await this.props.showPageWaitDialog(
      IntlUtil.getText(
        this._intl_ns_vpa_number_inventory,
        "notification.info.pleaseWaitRetrievingData"
      )
    );
    await getDevicesByNumberId(numberId)
      .then(async (res) => {
        if (
          res &&
          res.data &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data.records
        ) {
          this.setStateAsync({ deviceList: res.data.records });
          await this.props.hidePageWaitDialog();
        } else {
          await this.props.hidePageWaitDialog();
          await manageError(res, this.props.history);
        }
      })
      .catch(async (err) => {
        await this.props.hidePageWaitDialog();
        manageError(err, this.props.history);
      });
  };

  fetchInventoryDevices = async () => {
    await getDevice()
      .then(async (res) => {
        if (
          res &&
          res.data &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data.records
        ) {
          this.setStateAsync({ devicesAllRecord: res.data.records });
          await this.props.hidePageWaitDialog();
        } else {
          await this.props.hidePageWaitDialog();
          await manageError(res, this.props.history);
        }
      })
      .catch(async (err) => {
        await this.props.hidePageWaitDialog();
        manageError(err, this.props.history);
      });
  };

  handleAddNumber = async () => {
    await this.props.history.push(VoiceAdminURLProps.numberAdd);
  };

  clearAlert = async () => {
    await this.setStateAsync({
      showAlert: false,
      showSyncAlert: false,
      errorMessage: null,
      errorDetails: null,
      successMessage: null,
    });
  };

  clearSearchData = async () => {
    await this.setStateAsync({ searchValue: "", searchKeyword: "" });
  };

  handleSearchChange = async (e) => {
    e.preventDefault();
    await this.setStateAsync({ searchValue: e.target.value });
  };

  handleSearchCancel = async (e) => {
    e.preventDefault();
    await this.clearAlert();
    await this.setStateAsync({ isListDataFetched: false });
    let sortedRecords = await sortInventoryNumbers(
      this.props.inventoryNumbersAllRecords,
      this.state.sortedColumn,
      this.state.sortedOrder
    );
    await this.props.setInventoryNumbersDisplayRecords(sortedRecords);
    let pageOffset = 0;
    let slicedRecords = await sliceInventoryNumbers(
      this.props.inventoryNumbersDisplayRecords,
      pageOffset,
      this.state.pageLimit
    );
    await this.props.setInventoryNumbersPageRecords(slicedRecords);

    await this.setStateAsync({ searchKeyword: "", searchValue: "" });
    await this.setStateAsync({ pageOffset: pageOffset });
    await this.setStateAsync({ isListDataFetched: true });
  };

  handleSearchSubmit = async (e) => {
    e.preventDefault();
    await this.clearAlert();
    await this.setStateAsync({ isListDataFetched: false });
    if (
      this.props.inventoryNumbersAllRecords &&
      this.props.inventoryNumbersAllRecords.length > 0
    ) {
      let searchKeyword = this.state.searchValue;
      await this.setStateAsync({ searchKeyword: searchKeyword });
      let searchedRecords = await searchInventoryNumbers(
        this.props.inventoryNumbersAllRecords,
        this.state.searchKeyword,
        this.props.subscriberAccount?.voiceNumbersPrivilege
      );

      let sortedRecords = await sortInventoryNumbers(
        searchedRecords,
        this.state.sortedColumn,
        this.state.sortedOrder
      );
      await this.props.setInventoryNumbersDisplayRecords(sortedRecords);

      let pageOffset = 0;
      let slicedRecords = await sliceInventoryNumbers(
        this.props.inventoryNumbersDisplayRecords,
        pageOffset,
        this.state.pageLimit
      );

      await this.props.setInventoryNumbersPageRecords(slicedRecords);
      await this.setStateAsync({ pageOffset: pageOffset });
      await this.setStateAsync({ isListDataFetched: true });
    }
  };
  handleSortChange = async (sortColumn, sortOrder) => {
    await this.clearAlert();
    await this.setStateAsync({ isListDataFetched: false });
    let sortedRecords = await sortInventoryNumbers(
      this.props.inventoryNumbersDisplayRecords,
      sortColumn,
      sortOrder
    );
    await this.props.setInventoryNumbersDisplayRecords(sortedRecords);

    await this.setStateAsync({
      sortedColumn: sortColumn,
      sortedOrder: sortOrder,
    });

    let pageOffset = 0;
    let slicedRecords = await sliceInventoryNumbers(
      this.props.inventoryNumbersDisplayRecords,
      pageOffset,
      this.state.pageLimit
    );

    await this.props.setInventoryNumbersPageRecords(slicedRecords);
    await this.setStateAsync({ searchValue: this.state.searchKeyword });
    await this.setStateAsync({ pageOffset: pageOffset });
    await this.setStateAsync({ isListDataFetched: true });
  };

  handlePageOffsetChange = async (pageOffset) => {
    await this.clearAlert();
    await this.setStateAsync({ isListDataFetched: false });
    if (pageOffset >= 0) {
      let slicedRecords = await sliceInventoryNumbers(
        this.props.inventoryNumbersDisplayRecords,
        pageOffset,
        this.state.pageLimit
      );
      await this.props.setInventoryNumbersPageRecords(slicedRecords);
      await this.setStateAsync({ searchValue: this.state.searchKeyword });
      await this.setStateAsync({ pageOffset: pageOffset });
    }
    await this.setStateAsync({ isListDataFetched: true });
  };

  handlePageLimitChange = async (pageLimit) => {
    await this.clearAlert();
    await this.setStateAsync({ isListDataFetched: false });
    if (pageLimit > 0) {
      let pageOffset = 0;
      let slicedRecords = await sliceInventoryNumbers(
        this.props.inventoryNumbersDisplayRecords,
        pageOffset,
        pageLimit
      );
      await this.props.setInventoryNumbersPageRecords(slicedRecords);
      await this.setStateAsync({ searchValue: this.state.searchKeyword });
      await this.setStateAsync({ pageOffset: pageOffset });
      await this.setStateAsync({ pageLimit: pageLimit });
    }
    await this.setStateAsync({ isListDataFetched: true });
  };

  handleEditNumber(id) {
    this.props.history.push(VoiceAdminURLProps.numberEdit.replace(":nid", id));
  }

  handleNumberOrder = async () => {
    this.props.history.push(VoiceAdminURLProps.numberOrder);
  };

  refreshPropagation = async () => {
    await this.clearAlert();
    const identitySession = checkIdentitySessionValid(this._cancelToken);
    if (identitySession === true) {
      await this.props.showPageWaitDialog(
        IntlUtil.getText(
          this._intl_ns_vpa_number_inventory,
          "notification.info.pleaseWaitRetrievingData"
        )
      );
      await this.fetchInventoryNumbers();
      await this.props.hidePageWaitDialog();
      await this.setStateAsync({ isFormDataFilled: false });
    } else {
      this.props.history.push(VoiceAdminURLProps.home);
    }
  };

  renderPaginationInfo = () => {
    if (
      this.props.inventoryNumbersDisplayRecords &&
      this.props.inventoryNumbersDisplayRecords.length > this.state.pageLimit
    ) {
      let start = this.state.pageOffset * this.state.pageLimit;
      let end = start + this.state.pageLimit;
      if (end > this.props.inventoryNumbersDisplayRecords.length)
        end = this.props.inventoryNumbersDisplayRecords.length;
      return (
        <>
          &nbsp;
          {IntlUtil.getSubstituteText(
            this._intl_ns_vpa_number_inventory,
            "content.displayingStartToEnd",
            [
              {
                key: "<START>",
                value: start + 1,
              },
              {
                key: "<END>",
                value: end,
              },
            ]
          )}
        </>
      );
    } else {
      return null;
    }
  };

  renderOrderNumbersInfo = () => {
    if (
      this.props.numberOrderedRecords &&
      this.props.numberOrderedRecords.length > 0
    ) {
      const orderedNumbers = this.props.inventoryNumbersAllRecords.filter(
        (number) => this.props.numberOrderedRecords.includes(number.phoneNumber)
      );
      return (
        <>
          <Text
            content={IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "content.orderedNumbers"
            )}
            onClick={() => this.setStateAsync({ orderedNumbersDialog: true })}
            className="page-text text-fs-s text-fc-primary cursor-pointer"
          />
          <Dialog
            className="vpa-bn-dialog"
            backdrop={true}
            open={this.state.orderedNumbersDialog}
            content={
              <>
                <Text className="page-text text-semibold vpa-dialog-header text-fc-primary">
                  {IntlUtil.getText(
                    this._intl_ns_vpa_number_inventory,
                    "content.orderedNumbersDialog"
                  )}
                </Text>
                <Divider size={1} />
                <Grid fluid className="page-grid m-l-0 p-l-0">
                  <div className="vpa-inventory-ordered-number p-l-0 p-t-0">
                    <Row className="m-t-10 m-b-10 m-l-0 p-l-0">
                      <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                        <Text>
                          {IntlUtil.getText(
                            this._intl_ns_vpa_number_inventory,
                            "content.orderedPhoneNumber"
                          )}
                        </Text>
                      </Col>
                      <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                        <Text>
                          {IntlUtil.getText(
                            this._intl_ns_vpa_number_inventory,
                            "content.edit"
                          )}
                        </Text>
                      </Col>
                    </Row>
                    {orderedNumbers && orderedNumbers.length > 0 ? (
                      <>
                        {orderedNumbers.map((ordered) => {
                          return (
                            <Row className="m-t-10 m-b-10 m-l-0 p-l-0">
                              <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                                <Text className="page-text">
                                  {`+${ordered.phoneNumber}`}
                                </Text>
                              </Col>
                              <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                                <Button
                                  text
                                  primary
                                  iconOnly
                                  icon={<EditIcon className="p-b-10" />}
                                  onClick={() =>
                                    this.handleEditNumber(ordered.numberId)
                                  }
                                />
                              </Col>
                            </Row>
                          );
                        })}
                      </>
                    ) : null}
                  </div>
                </Grid>
                <Button
                  onClick={() =>
                    this.setStateAsync({ orderedNumbersDialog: false })
                  }
                  content={IntlUtil.getText(
                    this._intl_ns_vpa_number_inventory,
                    "content.close"
                  )}
                />
              </>
            }
          />
        </>
      );
    }
  };

  getInventoryStatistics = async () => {
    // Managed
    let totalManagedRecord = 0;
    let totalManagedUnassigned = 0;
    let totalManagedAssigned = 0;
    let totalManagedReserved = 0;
    // Unmanaged
    let totalUnmanagedRecord = 0;
    let totalUnmanagedAssigned = 0;
    let totalUnmanagedUnassigned = 0;
    let totalUnmanagedReserved = 0;
    if (
      this.props.inventoryNumbersAllRecords &&
      this.props.inventoryNumbersAllRecords.length > 0
    ) {
      this.props.inventoryNumbersAllRecords.forEach((numberRecords) => {
        if (
          numberRecords.manageStatus?.toLowerCase().trim() ===
          VoiceAdminConstants.INVENTORY.MANAGE_STATUS.MANAGED.toLowerCase()
        ) {
          // Managed
          totalManagedRecord++;
          if (
            numberRecords.reserveStatus?.toLowerCase().trim() ===
            VoiceAdminConstants.INVENTORY.RESERVED_STATUS.RESERVED.toLowerCase()
          ) {
            totalManagedReserved++;
          }
          if (
            numberRecords.assignStatus?.toLowerCase().trim() ===
            VoiceAdminConstants.INVENTORY.ASSIGN_STATUS.ASSIGNED.toLowerCase()
          ) {
            totalManagedAssigned++;
          } else {
            totalManagedUnassigned++;
          }
        } else {
          // Unmanaged
          totalUnmanagedRecord++;
          if (
            numberRecords.reserveStatus?.toLowerCase().trim() ===
            VoiceAdminConstants.INVENTORY.RESERVED_STATUS.RESERVED.toLowerCase()
          ) {
            totalUnmanagedReserved++;
          }
          if (
            numberRecords.assignStatus?.toLowerCase().trim() ===
            VoiceAdminConstants.INVENTORY.ASSIGN_STATUS.ASSIGNED.toLowerCase()
          ) {
            totalUnmanagedAssigned++;
          } else {
            totalUnmanagedUnassigned++;
          }
        }
      });
    }
    await this.setStateAsync({
      numbersStatistics: {
        // Managed
        totalManagedRecord: totalManagedRecord,
        totalManagedAssigned: totalManagedAssigned,
        totalManagedUnassigned: totalManagedUnassigned,
        totalManagedReserved: totalManagedReserved,
        // Unmanaged
        totalUnmanagedRecord: totalUnmanagedRecord,
        totalUnmanagedAssigned: totalUnmanagedAssigned,
        totalUnmanagedUnassigned: totalUnmanagedUnassigned,
        totalUnmanagedReserved: totalUnmanagedReserved,
      },
    });
  };

  handleShowDeleteDialog = async (number) => {
    if (number) {
      await this.clearAlert();
      await this.setState({ numberSelect: number });
      await this.setState({ isNumberDeleteModal: true });
    }
  };

  handleShowDeviceDialog = async (number) => {
    if (number) {
      await this.clearAlert();
      await this.setState({ numberSelect: number });
      await this.fetchDevicesByNumberId(number.numberId);
      await this.setState({ isNumberDeviceModal: true });
    }
  };

  renderNumberDeviceDialog = () => {
    if (this.state.numberSelect) {
      return (
        <Dialog
          cancelButton={IntlUtil.getText(
            this._intl_ns_vpa_number_inventory,
            "content.close"
          )}
          onCancel={() => this.setState({ isNumberDeviceModal: false })}
          open={this.state.isNumberDeviceModal}
          // className="vpa-page-dialog"
          content={
            <>
              <Text className="page-text text-semibold vpa-dialog-header text-fc-primary">
                {IntlUtil.getSubstituteText(
                  this._intl_ns_vpa_number_inventory,
                  "content.devicesTitle",
                  [
                    {
                      key: "<PHONENUMBER>",
                      value: this.state.numberSelect?.phoneNumber,
                    },
                  ]
                )}
              </Text>
              <Divider size={1} />
              {this.state.deviceList && this.state.deviceList.length > 0 ? (
                <Table className="vpa-dialog-table-wrapper">
                  <Flex className="vpa-dialog-table-header-wrapper">
                    <TableRow header className="vpa-dialog-table-header-row">
                      {DeviceModalTableHeaderColumns(
                        this._intl_ns_vpa_number_inventory
                      ).map((column, index) => {
                        return (
                          <TableCell
                            key={column.key}
                            className="vpa-dialog-table-header-cell"
                          >
                            {column.content}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </Flex>
                  <Flex column className="vpa-dialog-table-data-wrapper">
                    {this.state.deviceList.map((data, index) => {
                      return (
                        <TableRow
                          key={`device-list-${index}`}
                          className="vpa-dialog-table-data-row"
                        >
                          <TableCell className="vpa-dialog-table-data-cell">
                            <Texty className="page-text">
                              {data.deviceTypeName}
                            </Texty>
                          </TableCell>
                          <TableCell className="vpa-dialog-table-data-cell">
                            <Texty className="page-text">{data.makeName}</Texty>
                          </TableCell>
                          <TableCell className="vpa-dialog-table-data-cell">
                            <Texty className="page-text">
                              {data.modelName}
                            </Texty>
                          </TableCell>
                          <TableCell className="vpa-dialog-table-data-cell">
                            <Texty className="page-text">
                              {data.serialNumber}
                            </Texty>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Flex>
                </Table>
              ) : (
                <Flex inline gap="gap.large" className="m-t-10">
                  <Flex>
                    <Text className="page-text text-fs-s text-fc-dark">
                      {IntlUtil.getText(
                        this._intl_ns_vpa_number_inventory,
                        "notification.info.noDeviceFound"
                      )}
                    </Text>
                  </Flex>
                </Flex>
              )}
            </>
          }
          footer={{
            children: (Component, props) => {
              const { styles, ...rest } = props;
              return (
                <Flex
                  styles={styles}
                  className="matgin-left-none margin-right-auto"
                >
                  <Flex.Item push>
                    <Component {...rest} />
                  </Flex.Item>
                </Flex>
              );
            },
          }}
        />
      );
    }
  };

  renderNumberDeleteDialog = () => {
    if (this.state.numberSelect) {
      return (
        <Dialog
          backdrop={true}
          cancelButton={IntlUtil.getText(
            this._intl_ns_vpa_number_inventory,
            "content.no"
          )}
          confirmButton={IntlUtil.getText(
            this._intl_ns_vpa_number_inventory,
            "content.yes"
          )}
          onConfirm={() => {
            this.deleteNumber(this.state.numberSelect.numberId);
          }}
          onCancel={() => {
            this.handleHideDeleteDialog();
          }}
          open={this.state.isNumberDeleteModal}
          content={
            <Grid fluid className="p-l-0 p-r-0">
              <Row className="m-t-10 m-b-10 m-l-0 p-l-0">
                <Col xs={12} md={12} lg={12} xl={12}>
                  <Text className="vpa-page-dialog-info-text">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "notification.info.deletePermanentlyTextPrefixNumber"
                    )}
                    <b className="m-l-5">
                      {this.state.numberSelect.phoneNumber}
                    </b>
                    {IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "notification.info.deletePermanentlyTextSuffix"
                    )}
                  </Text>
                </Col>
                <Col xs={12} md={12} lg={12} xl={12}>
                  <Text
                    className="vpa-page-dialog-info-text"
                    content={IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "notification.info.deletePermanentlyText"
                    )}
                  />
                </Col>
              </Row>
            </Grid>
          }
          className="vpa-page-dialog"
        />
      );
    }
  };

  renderImportDialog = () => {
    return (
      <NumberImport
        showDialogBox={this.state.showImportDialog}
        hideDialogBox={() => this.setState({ showImportDialog: false })}
        fetchNumbersData={async () => {
          await this.fetchInventoryNumbers();
          await this.getInventoryStatistics();
          await this.handlePageOffsetChange(
            VoiceAdminConstants.TABLE_DATA.PAGE_OFFSET_DEFAULT
          );
        }}
      />
    );
  };

  renderExportDialog = () => {
    return (
      <NumberExport
        showDialogBox={this.state.showExportDialog}
        hideDialogBox={() => this.setStateAsync({ showExportDialog: false })}
        numberRecord={this.props.inventoryNumbersAllRecords}
        deviceRecord={this.state.devicesAllRecord}
        countryRecord={this.props.countryStatesData}
        fetchDevicesData={async () => {
          await this.fetchInventoryDevices();
        }}
        fetchNumbersData={async () => {
          await this.fetchInventoryNumbers();
        }}
      />
    );
  };

  renderDownloadInfoDialog = () => {
    return (
      <Dialog
        backdrop={true}
        confirmButton={IntlUtil.getText(
          this._intl_ns_vpa_number_inventory,
          "content.ok"
        )}
        onConfirm={() => {
          this.setState({
            showDownloadStatusDialog: false,
          });
        }}
        open={this.state.showDownloadStatusDialog}
        content={
          <Text
            className="vpa-page-dialog-info-text"
            content={this.state.infoMessage}
          />
        }
        className="vpa-page-dialog"
      />
    );
  };

  getNumbersSyncInfoText = (timeStamp) => {
    if (timeStamp) {
      let propagationTimestamp = timeStamp.createTimestamp;
      if (
        timeStamp.endTimestamp &&
        timeStamp.endTimestamp !== "0001-01-01T00:00:00"
      ) {
        propagationTimestamp = timeStamp.endTimestamp;
      }
      const timestampObj = moment(propagationTimestamp);
      const dateString = timestampObj.format("ll");
      const timeString = timestampObj.format("LTS");

      let text = IntlUtil.getText(
        this._intl_ns_vpa_number_inventory,
        "notification.info.lastSyncDate"
      );
      if (timestampObj && dateString && timeString) {
        text =
          text +
          " " +
          IntlUtil.getSubstituteText(
            this._intl_ns_vpa_number_inventory,
            "notification.info.numbersDataSyncDateTime",
            [
              {
                key: "<DATE>",
                value: dateString,
              },
              {
                key: "<TIME>",
                value: timeString,
              },
            ]
          );
      }
      return text;
    } else return "";
  };

  inventoryNumbersSync = async () => {
    await this.setStateAsync({ showSyncDialog: true });
  };

  renderNumbersSyncDialog = () => {
    if (this.state.showSyncDialog)
      return (
        <NumbersSyncDialog
          showSyncDialog={this.state.showSyncDialog}
          syncResponse={this.state.syncTenantAccountRecords}
          numbersSyncCompleted={this.numbersSyncCompleted}
          closeNumberSyncDialog={this.closeNumberSyncDialog}
          syncResponseUpdate={this.syncResponseUpdate}
          isNumberInventoryPage={true}
        />
      );
  };

  syncNumbersInProgressUpdate = async (isInProgress) => {
    await this.setStateAsync({ syncNumbersInProgress: isInProgress });
  };

  syncResponseUpdate = async (syncResponse) => {
    await this.setStateAsync({ syncTenantAccountRecords: syncResponse });
  };

  closeNumberSyncDialog = async () => {
    await this.setStateAsync({ showSyncDialog: false });
    if (this.state.numberRemoved) {
      await this.setStateAsync({ numberRemoved: false });
    }
  };

  numbersSyncCompleted = async () => {
    await this.fetchInventoryNumbers();
    await this.getInventoryStatistics();
  };

  handleHideDeleteDialog = async () => {
    await this.setState({ isNumberDeleteModal: false });
  };

  deleteNumber = async (numberId) => {
    await this.clearAlert();
    await this.setStateAsync({ isNumberDeleteModal: false });
    if (numberId) {
      await this.props.showPageWaitDialog(
        IntlUtil.getText(
          this._intl_ns_vpa_number_inventory,
          "notification.info.pleaseWaiDeletingNumberData"
        )
      );
      await deleteInventoryNumber(numberId, this._cancelToken)
        .then(async (res) => {
          if (res && res.status === AppConfigProps.httpStatusCode.ok) {
            await this.fetchInventoryNumbers();
            await this.getInventoryStatistics();
            await this.setStateAsync({
              successMessage: IntlUtil.getText(
                this._intl_ns_vpa_number_inventory,
                "notification.success.deletedNumber"
              ),
              showAlert: true,
            });
            await this.props.hidePageWaitDialog();
          } else {
            await manageError(res, this.props.history);
            await this.props.hidePageWaitDialog();
          }
        })
        .catch(async (err) => {
          await this.props.hidePageWaitDialog();
          const errorStatus = ResponseUtil.getStatus(err);
          if (
            errorStatus &&
            errorStatus === AppConfigProps.httpStatusCode.badRequest
          ) {
            await this.setStateAsync({
              errorMessage: IntlUtil.getText(
                this._intl_ns_vpa_number_inventory,
                "notification.error.deleteNumberFailed"
              ),
              showAlert: true,
            });
          } else {
            await manageError(err, this.props.history);
          }
        });
    }
  };

  downloadPropagation = async () => {
    await this.clearAlert();
    if (
      this.state.numbersPropagation &&
      this.state.numbersPropagation.overallStatus ===
        VoiceAdminConstants.INVENTORY.DATA_PROPAGATION.OVERALL_STATUS_COMPLETED
    ) {
      await this.props.showPageWaitDialog(
        IntlUtil.getText(
          this._intl_ns_vpa_number_inventory,
          "notification.info.pleaseWaitDownloadingData"
        )
      );
      if (this.state.numbersPropagation.dataType === "Numbers") {
        await this.setStateAsync({ showDownloadStatusDialog: false });
        await this.setState({ infoMessage: null });
        let records=this.state.numbersPropagation.data;
              if(records?.length>0){
                records=records.map(rec=>{
                  if(rec?.classification?.toLowerCase().trim()===VoiceAdminConstants.INVENTORY.CLASSIFICATION_TYPE.STORE?.toLowerCase().trim()){
                    rec.classification=VoiceAdminConstants.INVENTORY.CLASSIFICATION_TYPE.E_FAX;
                  }
                  return {...rec}
                })
              }
        const csvFileData = await getInventoryDownloadFileData(
          this.props.countryStatesData,
          this._intl_ns_vpa_number_inventory,
          records
        );
        const csvFileName = "numbers_update_result.csv";
        PageUtil.downloadCSVFile(csvFileName, csvFileData);
        await setTimeout(async () => {
          await this.setState({
            infoMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.info.downloadNumbers"
            ),
          });
          await this.setStateAsync({ showDownloadStatusDialog: true });
          await this.props.hidePageWaitDialog();
        }, 5000);
      } else {
        await this.setStateAsync({ showDownloadStatusDialog: false });
        await this.setState({ infoMessage: null });
        const csvFileData = await downloadDeviceFileData(
          this.props.countryStatesData,
          this._intl_ns_vpa_number_inventory,
          this.state.numbersPropagation.data
        );
        const csvFileName = "devices_update_result.csv";
        PageUtil.downloadCSVFile(csvFileName, csvFileData);
        await setTimeout(async () => {
          await this.setState({
            infoMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.info.downloadDevices"
            ),
          });
          await this.setStateAsync({ showDownloadStatusDialog: true });
          await this.props.hidePageWaitDialog();
        }, 5000);
      }
    }
  };

  showImportInventory = async () => {
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await this.setState({ showImportDialog: true });
    } else {
      this.props.history.push(AppURLProps.signin);
    }
  };

  showExportInventory = async () => {
    await this.clearAlert();
    let identitySession = checkIdentitySession();
    if (identitySession === true) {
      await this.setStateAsync({ showExportDialog: true });
    } else {
      this.props.history.push(AppURLProps.signin);
    }
  };

  getNumbersPropagationInfoText = (propagation) => {
    if (propagation) {
      let propagationTimestamp = propagation.createTimestamp;
      if (
        propagation.endTimestamp &&
        propagation.endTimestamp !== "0001-01-01T00:00:00"
      ) {
        propagationTimestamp = propagation.endTimestamp;
      }
      const timestampObj = moment(propagationTimestamp);
      const dateString = timestampObj.format("ll");
      const timeString = timestampObj.format("LTS");

      let text =
        propagation?.dataType === "Devices"
          ? IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.info.devicesDataPropagationCompleted"
            )
          : IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.info.numbersDataPropagationCompleted"
            );

      if (timestampObj && dateString && timeString) {
        text =
          text +
          " " +
          IntlUtil.getSubstituteText(
            this._intl_ns_vpa_number_inventory,
            "notification.info.numbersDataPropagationDateTime",
            [
              {
                key: "<DATE>",
                value: dateString,
              },
              {
                key: "<TIME>",
                value: timeString,
              },
            ]
          );
      }
      return text;
    } else return "";
  };

  setFilterData = async () => {
    let managedRecords = [
      {
        key: "All Numbers",
        header: "All Numbers",
      },
    ];
    let platFormRecords = [];
    let countryRecords = [];
    let numberTypeRecords = [];
    let carrierRecords = [];
    if (
      this.props.inventoryNumbersAllRecords &&
      this.props.inventoryNumbersAllRecords.length > 0
    ) {
      this.props.inventoryNumbersAllRecords.forEach((rec) => {
        if (rec.manageStatus !== null && rec.manageStatus !== "") {
          managedRecords.push({
            key: rec.manageStatus,
            header: rec.manageStatus,
          });
        }
      });

      managedRecords = _.uniqBy(managedRecords, "key");
      managedRecords = _.orderBy(
        managedRecords,
        [(obj) => obj.key?.toLowerCase().trim()],
        "asc"
      );

      this.props.inventoryNumbersAllRecords.forEach((rec) => {
        if (
          rec.communicationPlatform !== null &&
          rec.communicationPlatform !== ""
        ) {
          platFormRecords.push({
            key: rec.communicationPlatform,
            header: rec.communicationPlatform,
          });
        }
      });

      platFormRecords = _.uniqBy(platFormRecords, "key");
      platFormRecords = _.orderBy(
        platFormRecords,
        [(obj) => obj.key?.toLowerCase().trim()],
        "asc"
      );

      this.props.inventoryNumbersAllRecords.forEach((rec) => {
        if (rec.country !== null && rec.country !== "") {
          countryRecords.push({
            key: rec.numberCountryName,
            header: rec.numberCountryName,
          });
        }
      });
      countryRecords = _.uniqBy(countryRecords, "key");
      countryRecords = _.orderBy(
        countryRecords,
        [(obj) => obj.key?.toLowerCase().trim()],
        "asc"
      );

      this.props.inventoryNumbersAllRecords.forEach((rec) => {
        if (rec.numberTypeName !== null && rec.numberTypeName !== "") {
          numberTypeRecords.push({
            key: rec.numberTypeName,
            header: rec.numberTypeName,
          });
        }
      });
      numberTypeRecords = _.uniqBy(numberTypeRecords, "key");
      numberTypeRecords = _.orderBy(
        numberTypeRecords,
        [(obj) => obj.key?.toLowerCase().trim()],
        "asc"
      );

      this.props.inventoryNumbersAllRecords.forEach((rec) => {
        if (rec.carrierName !== null && rec.carrierName !== "") {
          carrierRecords.push({
            key: rec.carrierName,
            header: rec.carrierName,
          });
        }
      });
      carrierRecords = _.uniqBy(carrierRecords, "key");
      carrierRecords = _.orderBy(
        carrierRecords,
        [(obj) => obj.key?.toLowerCase().trim()],
        "asc"
      );
      await this.setStateAsync({
        numberFilterData: {
          ...this.state.numberFilterData,
          managedRecords: managedRecords,
          platFormRecords: platFormRecords,
          countryRecords: countryRecords,
          numberTypeRecords: numberTypeRecords,
          carrierRecords: carrierRecords,
        },
      });
    }
  };

  handleFilterPanelOpen = async () => {
    await this.setStateAsync({
      isFilterPanelOpen: true,
    });
  };

  handleFilterPanelClose = async () => {
    await this.setStateAsync({
      isFilterPanelOpen: false,
    });
  };

  setFormFieldFilterValue = async (fieldName, fieldValue) => {
    await this.setStateAsync({
      numberFilterSelectedData: {
        ...this.state.numberFilterSelectedData,
        [fieldName]: fieldValue,
      },
    });
  };

  handleFormFieldFilter = async (fieldName, option) => {
    if (fieldName === "selectedManagedStatus") {
      await this.setFormFieldFilterValue(fieldName, option.value.key);
    } else {
      await this.setFormFieldFilterValue(fieldName, option.value);
    }
  };

  handleRemoveFilterItem = async (fieldName, item) => {
    let removeSelectedItem = this.state.numberFilterSelectedData[
      fieldName
    ].filter((key) => key !== item.key);
    await this.setFormFieldFilterValue(fieldName, removeSelectedItem);
  };

  handleFilterApply = async (page = null) => {
    let filters = null;
    if (
      this.state.numberFilterSelectedData.selectedManagedStatus ===
      "All Numbers"
    ) {
      filters = {
        manageStatus: [],
        communicationPlatform:
          this.state.numberFilterSelectedData.selectedPlatForms.map(
            (rec) => rec.key
          ),
        numberCountryName:
          this.state.numberFilterSelectedData.selectedCountries.map(
            (rec) => rec.key
          ),
        numberTypeName:
          this.state.numberFilterSelectedData.selectedNumberTypes.map(
            (rec) => rec.key
          ),
        carrierName: this.state.numberFilterSelectedData.selectedCarriers.map(
          (rec) => rec.key
        ),
      };
    } else {
      filters = {
        manageStatus: [
          this.state.numberFilterSelectedData.selectedManagedStatus,
        ],
        communicationPlatform:
          this.state.numberFilterSelectedData.selectedPlatForms.map(
            (rec) => rec.key
          ),
        numberCountryName:
          this.state.numberFilterSelectedData.selectedCountries.map(
            (rec) => rec.key
          ),
        numberTypeName:
          this.state.numberFilterSelectedData.selectedNumberTypes.map(
            (rec) => rec.key
          ),
        carrierName: this.state.numberFilterSelectedData.selectedCarriers.map(
          (rec) => rec.key
        ),
      };
    }

    let numberFilterData = numberMultipleFilterCriteriaArray(
      this.props.inventoryNumbersAllRecords,
      filters
    );

    let searchedRecords = await searchInventoryNumbers(
      numberFilterData,
      this.state.searchKeyword,
      this.props.subscriberAccount?.voiceNumbersPrivilege
    );

    let sortedRecords = await sortInventoryNumbers(
      searchedRecords,
      this.state.sortedColumn,
      this.state.sortedOrder
    );
    await this.props.setInventoryNumbersDisplayRecords(sortedRecords);

    let slicedRecords = await sliceInventoryNumbers(
      this.props.inventoryNumbersDisplayRecords,
      this.state.pageOffset,
      this.state.pageLimit
    );
    await this.props.setInventoryNumbersPageRecords(slicedRecords);

    if (page !== "clear") {
      await this.setStateAsync({
        isFilterPanelOpen: false,
      });
    }

    let isFilterApplied = false;
    if (
      this.state.numberFilterSelectedData.selectedManagedStatus !==
      "All Numbers"
    ) {
      isFilterApplied =
        this.state.numberFilterSelectedData.selectedManagedStatus?.length > 0 ||
        this.state.numberFilterSelectedData.selectedPlatForms.length > 0 ||
        this.state.numberFilterSelectedData.selectedCountries.length > 0 ||
        this.state.numberFilterSelectedData.selectedNumberTypes.length > 0 ||
        this.state.numberFilterSelectedData.selectedCarriers.length > 0
          ? true
          : false;
    } else {
      isFilterApplied =
        this.state.numberFilterSelectedData.selectedPlatForms.length > 0 ||
        this.state.numberFilterSelectedData.selectedCountries.length > 0 ||
        this.state.numberFilterSelectedData.selectedNumberTypes.length > 0 ||
        this.state.numberFilterSelectedData.selectedCarriers.length > 0
          ? true
          : false;
    }
    await this.setStateAsync({
      isFilterApplied: isFilterApplied,
    });
  };

  handleFilterClear = async () => {
    await this.setFilterData();
    await this.setStateAsync({
      numberFilterSelectedData: this.initNumberFilterSelectedData(),
    });
    await this.handleFilterApply("clear");
    await this.setStateAsync({
      isFilterApplied: false,
    });
  };

  renderFilterPanel = () => {
    if (this.state.isFilterPanelOpen === true) {
      return (
        <NumberFilter
          {...this.props}
          isFilterPanelOpen={this.state.isFilterPanelOpen}
          intlCommonNamespace={this._intl_ns_vpa_common}
          intlNamespace={this._intl_ns_vpa_number_inventory}
          numbersRecords={this.state.numberFilterData}
          numberFilterSelectedData={this.state.numberFilterSelectedData}
          handleFormFieldFilter={this.handleFormFieldFilter}
          handleRemoveFilterItem={this.handleRemoveFilterItem}
          handleFilterApply={this.handleFilterApply}
          handleFilterClear={this.handleFilterClear}
          handleFilterPanelClose={this.handleFilterPanelClose}
          communicationPlatformsData={this.props.communicationPlatformsData}
        />
      );
    }
  };

  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(
            this._intl_ns_vpa_number_inventory,
            "title.numberList"
          )}
        />
        <Flex column className="page-wrapper">
          <PageLoader
            status={this.state.isPageDataFetched}
            size="medium"
            labelPosition="below"
            label={IntlUtil.getText(
              this._intl_ns_common,
              "content.loadingInprogress"
            )}
            type="full-center"
          >
            <Grid fluid className="page-grid vpa-inv-page-content">
              <Row className="vpa-inv-row p-5">
                <Col
                  xl={1}
                  lg={2}
                  md={2}
                  sm={12}
                  xs={12}
                  className="m-t-0 p-t-0"
                >
                  <Text className="page-title-text vpa-inv-title">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "content.inventory"
                    )}
                  </Text>
                </Col>
                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={12}
                  xs={12}
                  className="vpa-inv-col-1"
                >
                  <Row>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Text
                        className="vpa-inv-col"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.totalRecords"
                        )}
                      />
                    </Col>
                    <Col xl={12}>
                      {this.props.inventoryNumbersAllRecords ? (
                        <Text
                          content={
                            this.props.inventoryNumbersAllRecords
                              ? parseInt(
                                  this.props.inventoryNumbersAllRecords.length
                                ).toLocaleString()
                              : 0
                          }
                        />
                      ) : null}
                    </Col>
                  </Row>
                </Col>
                <Col
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="vpa-inv-col-1"
                >
                  <Row>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Text
                        className="vpa-inv-col"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.managedNumbers"
                        )}
                      />
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.total"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalManagedRecord
                          ? parseInt(
                              this.state.numbersStatistics?.totalManagedRecord
                            ).toLocaleString()
                          : 0}
                      </span>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.assigned"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalManagedAssigned
                          ? parseInt(
                              this.state.numbersStatistics?.totalManagedAssigned
                            ).toLocaleString()
                          : 0}
                      </span>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.unassigned"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalManagedUnassigned
                          ? parseInt(
                              this.state.numbersStatistics
                                ?.totalManagedUnassigned
                            ).toLocaleString()
                          : 0}
                      </span>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.reserved"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalManagedReserved
                          ? parseInt(
                              this.state.numbersStatistics?.totalManagedReserved
                            ).toLocaleString()
                          : 0}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="vpa-inv-col-1"
                >
                  <Row>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Text
                        className="vpa-inv-col"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.unmanagedNumbers"
                        )}
                      />
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.total"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalUnmanagedRecord
                          ? parseInt(
                              this.state.numbersStatistics?.totalUnmanagedRecord
                            ).toLocaleString()
                          : 0}
                      </span>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.assigned"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalUnmanagedAssigned
                          ? parseInt(
                              this.state.numbersStatistics
                                ?.totalUnmanagedAssigned
                            ).toLocaleString()
                          : 0}
                      </span>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.unassigned"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalUnmanagedUnassigned
                          ? parseInt(
                              this.state.numbersStatistics
                                ?.totalUnmanagedUnassigned
                            ).toLocaleString()
                          : 0}
                      </span>
                      <span className="vpa-inv-span">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.reserved"
                        )}
                        :{" "}
                        {this.state.numbersStatistics?.totalUnmanagedReserved
                          ? parseInt(
                              this.state.numbersStatistics
                                ?.totalUnmanagedReserved
                            ).toLocaleString()
                          : 0}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="m-t-10">
                <Col
                  xs={12}
                  sm={12}
                  md={4}
                  lg={3}
                  xl={2}
                  className="m-b-10 vpa-inv-row-1"
                >
                  <Input
                    inline
                    inverted
                    placeholder={IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "content.search"
                    )}
                    className="vpa-usn-search-input text-fs-r"
                    value={this.state.searchValue}
                    onChange={this.handleSearchChange}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        this.handleSearchSubmit(e);
                      }
                    }}
                    icon={
                      this.state.searchValue.length === 0 ? (
                        <SearchIcon
                          className="cursor-pointer vpa-usn-search-icon"
                          onClick={this.handleSearchSubmit}
                        />
                      ) : (
                        <CloseIcon
                          className="cursor-pointer vpa-usn-search-icon"
                          onClick={this.handleSearchCancel}
                        />
                      )
                    }
                  />
                </Col>
                {this.state.showAlert === false ? (
                  <Col xs={12} sm={12} md={12} lg={7} xl={8}>
                    {this.state.numbersPropagation ? (
                      <>
                        {this.state.isAlterDataPropagated === false &&
                        this.state.infoMessage ? (
                          <Row>
                            <Col xs={12}>
                              <AlertInfoMessage
                                fitted={true}
                                content={this.state.infoMessage}
                                linkDetails={{
                                  label: IntlUtil.getText(
                                    this._intl_ns_vpa_number_inventory,
                                    "content.clickToRefresh"
                                  ),
                                  callback: this.refreshPropagation,
                                }}
                              />
                            </Col>
                          </Row>
                        ) : (
                          <Row>
                            <Col xs={12} lg={10} md={11}>
                              <AlertInfoMessage
                                fitted={true}
                                content={this.getNumbersPropagationInfoText(
                                  this.state.numbersPropagation
                                )}
                                linkDetails={{
                                  label: IntlUtil.getText(
                                    this._intl_ns_vpa_number_inventory,
                                    "content.clickToDownloadUpdateResult"
                                  ),
                                  callback: this.downloadPropagation,
                                }}
                              />
                              {this.renderDownloadInfoDialog()}
                            </Col>
                          </Row>
                        )}
                      </>
                    ) : null}
                  </Col>
                ) : null}
                {this.state.showAlert === true ? (
                  <Col xs={12} sm={12} md={8} lg={7} xl={8}>
                    <Row>
                      <Col xs={12} lg={12}>
                        {this.state.successMessage ? (
                          <AlertSuccessMessage
                            content={this.state.successMessage}
                          />
                        ) : null}
                      </Col>
                    </Row>
                  </Col>
                ) : null}
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={2}
                  xl={2}
                  className="m-b-10 vpa-inv-pagination-content-wrapper"
                >
                  {this.props.inventoryNumbersDisplayRecords &&
                  this.props.inventoryNumbersDisplayRecords.length > 0 ? (
                    <Row start={"xs"}>
                      <Col xs={12} xl={11} lg={12} md={10} xlOffset={1}>
                        <Flex className="vpa-inv-pagination-wrapper">
                          <TablePagination
                            pageOffset={this.state.pageOffset}
                            pageLimit={this.state.pageLimit}
                            totalRecords={
                              this.props.inventoryNumbersDisplayRecords.length
                            }
                            handlePageOffsetChange={this.handlePageOffsetChange}
                            handlePageLimitChange={this.handlePageLimitChange}
                          />
                        </Flex>
                      </Col>
                    </Row>
                  ) : null}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={9}
                  className="m-b-5 vpa-inv-row-1"
                >
                  {!this.props.inventoryNumbersDisplayRecords ||
                  this.props.inventoryNumbersDisplayRecords.length === 0 ? (
                    <Flex>
                      <Text className="page-text text-fs-s text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.noInventoryNumbersFound"
                        )}
                      </Text>
                    </Flex>
                  ) : (
                    <Flex>
                      <Text className="page-text text-fs-s text-fc-dark">
                        {IntlUtil.getSubstituteText(
                          this._intl_ns_vpa_number_inventory,
                          "content.countInventoryNumbersFound",
                          [
                            {
                              key: "<COUNT>",
                              value:
                                this.props.inventoryNumbersDisplayRecords
                                  .length,
                            },
                          ]
                        )}
                      </Text>

                      <Text className="page-text text-fs-s text-fc-dark">
                        {this.renderPaginationInfo()}
                      </Text>
                      <span className="p-l-15">
                        {this.renderOrderNumbersInfo()}
                      </span>
                    </Flex>
                  )}
                </Col>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} className="p-0">
                  <Row start="xs">
                    <Col xs={12} xl={12} lg={12} md={12}>
                      <Flex className="vpa-inv-col-align">
                        <Button
                          onClick={() => this.handleFilterPanelOpen()}
                          className={classNames("", {
                            border: this.state.isFilterApplied === true,
                          })}
                          text
                          primary
                          content={
                            <Text className="page-text text-fs-m text-fc-primary">
                              {IntlUtil.getText(
                                this._intl_ns_vpa_common,
                                "content.filter"
                              )}
                            </Text>
                          }
                          icon={<FilterIcon />}
                        />
                        <Button
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_number_inventory,
                            "content.sync"
                          )}
                          icon={<RetryIcon />}
                          onClick={this.inventoryNumbersSync}
                          text
                          primary
                        />
                      </Flex>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {this.state.numberSelect ? (
                <>
                  {this.renderNumberDeleteDialog()}
                  {this.renderNumberDeviceDialog()}
                </>
              ) : null}
              <Row>
                {this.props.inventoryNumbersPageRecords &&
                this.props.inventoryNumbersPageRecords.length > 0 ? (
                  <Col xs={12} className="p-l-0 p-r-0">
                    <Flex column className="m-t-10 vpa-inv-table-wrapper">
                      <Table aria-label="table">
                        <Flex column className="vpa-usn-table-header-wrapper">
                          <TableRow header className="vpa-inv-table-header-row">
                            {this.state.inventoryTableHeaderColumns.map(
                              (column) => {
                                return (
                                  <TableHeaderColumn
                                    {...column}
                                    key={column.columnId}
                                    sortedColumn={this.state.sortedColumn}
                                    sortedOrder={this.state.sortedOrder}
                                    sortFunction={this.handleSortChange}
                                  />
                                );
                              }
                            )}
                          </TableRow>
                        </Flex>
                        <PageLoader
                          status={this.state.isListDataFetched}
                          size="medium"
                          type="center"
                        >
                          <Flex column className="vpa-usn-table-data-wrapper">
                            {this.props.inventoryNumbersPageRecords.map(
                              (inventoryNumber, index) => {
                                let platformObj =
                                  getCommunicationPlatformByName(
                                    this.props.communicationPlatformsData,
                                    inventoryNumber?.communicationPlatform
                                  );
                                return (
                                  <TableRow key={`inv-${index}`}>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      <Texty className="page-text">
                                        {inventoryNumber.numberCountryName}
                                      </Texty>
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell min-w-160 max-w-160">
                                      {this.state.isAlterDataPropagated &&
                                      this.props.subscriberAccount
                                        ?.voiceNumbersPrivilege === true ? (
                                        <Texty
                                          className="page-text vpa-inv-text"
                                          onClick={() =>
                                            this.handleEditNumber(
                                              inventoryNumber.numberId
                                            )
                                          }
                                        >
                                          {`+${inventoryNumber.phoneNumber}`}
                                        </Texty>
                                      ) : (
                                        <Texty className="page-text">
                                          {`+${inventoryNumber.phoneNumber}`}
                                        </Texty>
                                      )}
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      <div className="cpl-img-wrapper">
                                        <div className="text-wrapper">
                                          <Tooltip
                                            content={handleCommunicationPlatformName(
                                              platformObj
                                            )}
                                            trigger={
                                              <Image
                                                className="cpl-image"
                                                src={platformObj?.platformIcon}
                                              />
                                            }
                                          />
                                        </div>
                                      </div>
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      {inventoryNumber.manageStatus &&
                                      inventoryNumber.manageStatus
                                        ?.toLowerCase()
                                        .trim() ===
                                        VoiceAdminConstants.INVENTORY.MANAGE_STATUS.MANAGED.toLowerCase() ? (
                                        <Texty className="page-text">
                                          {inventoryNumber.userName
                                            ? inventoryNumber.userName
                                            : inventoryNumber.assignStatus
                                            ? null
                                            : inventoryNumber?.communicationPlatform?.toLowerCase() ===
                                              VoiceAdminConstants.COMMUNICATION_PLATFORMS.MICROSOFT_TEAMS?.toLowerCase()
                                            ? "#"
                                            : ""}
                                        </Texty>
                                      ) : (
                                        <Texty className="page-text">
                                          {inventoryNumber.userName}
                                        </Texty>
                                      )}
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      <Texty className="page-text">
                                        {inventoryNumber.manageStatus &&
                                        inventoryNumber.manageStatus
                                          ?.toLowerCase()
                                          .trim() ===
                                          VoiceAdminConstants.INVENTORY.MANAGE_STATUS.MANAGED.toLowerCase() ? (
                                          <Texty className="page-text">
                                            {inventoryNumber.city
                                              ? inventoryNumber.city
                                              : inventoryNumber.userName
                                              ? null
                                              : inventoryNumber.assignStatus
                                              ? null
                                              : inventoryNumber?.communicationPlatform?.toLowerCase() ===
                                                VoiceAdminConstants.COMMUNICATION_PLATFORMS.MICROSOFT_TEAMS?.toLowerCase()
                                              ? "#"
                                              : ""}
                                          </Texty>
                                        ) : (
                                          <Texty className="page-text">
                                            {inventoryNumber.city}
                                          </Texty>
                                        )}
                                      </Texty>
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      {inventoryNumber.manageStatus &&
                                      inventoryNumber.manageStatus
                                        ?.toLowerCase()
                                        .trim() ===
                                        VoiceAdminConstants.INVENTORY.MANAGE_STATUS.MANAGED.toLowerCase() ? (
                                        <Texty className="page-text">
                                          {inventoryNumber.country
                                            ? inventoryNumber.country
                                            : inventoryNumber.userName
                                            ? null
                                            : inventoryNumber.assignStatus
                                            ? null
                                            : inventoryNumber?.communicationPlatform?.toLowerCase() ===
                                              VoiceAdminConstants.COMMUNICATION_PLATFORMS.MICROSOFT_TEAMS?.toLowerCase()
                                            ? "#"
                                            : ""}
                                        </Texty>
                                      ) : (
                                        <Texty className="page-text">
                                          {inventoryNumber.country}
                                        </Texty>
                                      )}
                                    </TableCell>
                                    {this.props.subscriberAccount
                                      ?.voiceNumbersPrivilege === true ? (
                                      <TableCell className="vpa-usn-table-data-cell">
                                        <Texty className="page-text">
                                          {inventoryNumber.carrierName}
                                        </Texty>
                                      </TableCell>
                                    ) : null}
                                    <TableCell className="vpa-usn-table-data-cell">
                                      <Texty className="page-text">
                                        {inventoryNumber.numberTypeName}
                                      </Texty>
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      <Texty className="page-text">
                                        {inventoryNumber.departmentName}
                                      </Texty>
                                    </TableCell>
                                    {this.props.subscriberAccount
                                      ?.voiceNumbersPrivilege === true ? (
                                      <TableCell className="vpa-usn-table-data-cell">
                                        <Button
                                          disabled={
                                            !this.state.isAlterDataPropagated
                                          }
                                          text
                                          primary
                                          iconOnly
                                          icon={
                                            <Tooltip
                                              content="View Devices"
                                              trigger={<PopupIcon />}
                                            />
                                          }
                                          onClick={() =>
                                            this.handleShowDeviceDialog(
                                              inventoryNumber
                                            )
                                          }
                                        />
                                      </TableCell>
                                    ) : null}
                                    <TableCell className="vpa-usn-table-data-cell">
                                      {inventoryNumber.manageStatus &&
                                      inventoryNumber.manageStatus
                                        ?.toLowerCase()
                                        .trim() ===
                                        VoiceAdminConstants.INVENTORY.MANAGE_STATUS.MANAGED.toLowerCase() ? (
                                        <AcceptIcon className="vpa-usn-cell-icon-active" />
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell min-w-130 max-w-130">
                                      <Texty className="page-text">
                                      {VoiceAdminConstants.INVENTORY.CLASSIFICATION_TYPE.E_FAX?.toLowerCase().trim()===inventoryNumber?.classification?.toLowerCase().trim()?VoiceAdminConstants.INVENTORY.CLASSIFICATION_TYPE.E_FAX:capitalizeFirstLetter(
                                          inventoryNumber?.classification
                                        )}

                                      </Texty>
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      {inventoryNumber.manageStatus &&
                                      inventoryNumber.manageStatus
                                        ?.toLowerCase()
                                        .trim() ===
                                        VoiceAdminConstants.INVENTORY.MANAGE_STATUS.MANAGED.toLowerCase() ? (
                                        <Texty className="page-text">
                                          {inventoryNumber.assignStatus
                                            ? inventoryNumber.assignStatus
                                            : inventoryNumber?.communicationPlatform?.toLowerCase() ===
                                              VoiceAdminConstants.COMMUNICATION_PLATFORMS.MICROSOFT_TEAMS?.toLowerCase()
                                            ? "#"
                                            : ""}
                                        </Texty>
                                      ) : (
                                        <Texty className="page-text">
                                          {inventoryNumber.assignStatus}
                                        </Texty>
                                      )}
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      {inventoryNumber.reserveStatus &&
                                      inventoryNumber.reserveStatus
                                        ?.toLowerCase()
                                        .trim() ===
                                        VoiceAdminConstants.INVENTORY.RESERVED_STATUS.RESERVED.toLowerCase() ? (
                                        <AcceptIcon className="vpa-usn-cell-icon-active" />
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      {inventoryNumber.numberNotes &&
                                      inventoryNumber.numberNotes !== "" ? (
                                        <Popup
                                          className="vpa-inv-popup"
                                          on="hover"
                                          trigger={
                                            <AcceptIcon className="vpa-usn-cell-icon-active" />
                                          }
                                          content={
                                            <>
                                              <Text
                                                content={
                                                  inventoryNumber.numberNotes
                                                }
                                              />
                                            </>
                                          }
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                    <TableCell className="vpa-usn-table-data-cell">
                                      <Flex gap="gap.small" vAlign="center">
                                        {this.props.subscriberAccount
                                          ?.voiceNumbersPrivilege === true ? (
                                          <Button
                                            disabled={
                                              !this.state.isAlterDataPropagated
                                            }
                                            text
                                            primary
                                            iconOnly
                                            icon={<EditIcon />}
                                            onClick={() =>
                                              this.handleEditNumber(
                                                inventoryNumber.numberId
                                              )
                                            }
                                          />
                                        ) : null}

                                        {inventoryNumber.manageStatus &&
                                        inventoryNumber.manageStatus
                                          ?.toLowerCase()
                                          .trim() ===
                                          VoiceAdminConstants.INVENTORY.MANAGE_STATUS.UNMANAGED.toLowerCase() &&
                                        inventoryNumber.carrierLock
                                          ?.toLowerCase()
                                          .trim() ===
                                          "No".toLowerCase().trim() ? (
                                          <Button
                                            disabled={
                                              !this.state.isAlterDataPropagated
                                            }
                                            text
                                            primary
                                            iconOnly
                                            icon={<TrashCanIcon />}
                                            onClick={() =>
                                              this.handleShowDeleteDialog(
                                                inventoryNumber
                                              )
                                            }
                                          />
                                        ) : null}
                                      </Flex>
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </Flex>
                        </PageLoader>
                      </Table>
                    </Flex>
                  </Col>
                ) : null}
              </Row>
              {this.props.subscriberAccount?.voiceNumbersPrivilege === true ? (
                <Row className="m-t-16-n">
                  <Col
                    xs={12}
                    md={12}
                    lg={7}
                    xl={7}
                    className="m-t-29 p-l-0 p-r-0"
                  >
                    <Button
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_number_inventory,
                        "content.import"
                      )}
                      primary
                      disabled={!this.state.isAlterDataPropagated}
                      className="vpa-usn-button"
                      onClick={() => this.showImportInventory()}
                    />
                    <Button
                      primary
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_number_inventory,
                        "content.export"
                      )}
                      disabled={
                        this.props.inventoryNumbersAllRecords.length === 0 ||
                        !this.state.isAlterDataPropagated
                      }
                      onClick={() => this.showExportInventory()}
                      className="vpa-usn-button"
                    />
                    {/* <Button
                    primary
                    content={IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "content.buyNumbers"
                    )}
                    onClick={this.handleNumberOrder}
                    className="vpa-usn-button"
                  /> */}
                    <Button
                      disabled={!this.state.isAlterDataPropagated}
                      primary
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_number_inventory,
                        "content.addNumber"
                      )}
                      onClick={this.handleAddNumber}
                      className="vpa-usn-button"
                    />
                  </Col>
                  <Col xs={12} md={12} lg={5} xl={5} className="m-t-25">
                    <Row start="xs">
                      <Col xs={12} xl={11} lg={12} md={10} xlOffset={1}>
                        <Flex className="vpa-inv-col-align">
                          <Text className="page-text text-fs-s text-fc-light">
                            {IntlUtil.getText(
                              this._intl_ns_vpa_number_inventory,
                              "notification.info.assignmentDetail"
                            )}
                          </Text>
                        </Flex>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : null}
            </Grid>
            {this.renderExportDialog()}
            {this.renderImportDialog()}
            {this.renderNumbersSyncDialog()}
            {this.renderFilterPanel()}
          </PageLoader>
        </Flex>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  inventoryNumbersAllRecords:
    state.inventoryNumberStore.inventoryNumbersAllRecords,
  subscriberAccount: state.subscriberStore.subscriberAccount,
  inventoryNumbersDisplayRecords:
    state.inventoryNumberStore.inventoryNumbersDisplayRecords,
  inventoryNumbersPageRecords:
    state.inventoryNumberStore.inventoryNumbersPageRecords,
  numberOrderedRecords: state.numberOrderStore.numberOrderedRecords,
  countryStatesData: state.generalStore.countryStatesData,
  communicationPlatformsData: state.generalStore.communicationPlatformsData,
});

const mapActionToProps = {
  setInventoryNumbersPageAllRecords,
  setInventoryNumbersDisplayRecords,
  setInventoryNumbersPageRecords,
  searchInventoryNumbers,
  sortInventoryNumbers,
  sliceInventoryNumbers,
  showPageWaitDialog,
  hidePageWaitDialog,
};

export default connect(mapStateToProps, mapActionToProps)(NumberList);
